var $c904c7984e9d5a1d$exports = {};
$c904c7984e9d5a1d$exports = {
    "alert": `H\xe4lytys`,
    "dismiss": `Hylk\xe4\xe4`
};


export {$c904c7984e9d5a1d$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
